import { useUiStore } from 'stores/uiStore';
import { Card } from 'types/generatedSchemaTypes';
import { TabBarIndicator } from 'types/states';
import {
  getAmountOfExpiredCards,
  getAmountOfExpiresSoonCards,
} from 'utils/paymentUtils';

export const getTabBarIndicator = (
  tabBarIndicatorsList: TabBarIndicator[],
  tabLocalizationKey: string
) => {
  return tabBarIndicatorsList.filter(
    (indicator) => indicator.tabLocalizationKey === tabLocalizationKey
  )[0];
};

export const handleCustomerCardIndicator = (cards?: Card[] | null) => {
  const amountOfExpiringSoonCards = cards
    ? getAmountOfExpiresSoonCards(cards)
    : 0;

  const amountOfExpiredCards = cards ? getAmountOfExpiredCards(cards) : 0;

  const { tabBarIndicators, setTabBarIndicators } = useUiStore.getState();

  if (amountOfExpiringSoonCards > 0) {
    setTabBarIndicators([
      {
        tabLocalizationKey: 'navigation.account',
        indicatorType: 'warning',
        indicatorNumber: amountOfExpiringSoonCards,
        indicatorRef: 'CARD_EXPIRING_SOON',
      },
    ]);
  } else if (amountOfExpiredCards > 0) {
    setTabBarIndicators([
      {
        tabLocalizationKey: 'navigation.account',
        indicatorType: 'error',
        indicatorNumber: amountOfExpiredCards,
        indicatorRef: 'CARD_EXPIRING_SOON',
      },
    ]);
  } else {
    setTabBarIndicators(
      tabBarIndicators.filter(
        (indicator) => indicator.indicatorRef !== 'CARD_EXPIRING_SOON'
      )
    );
  }
};

export const resetTabBarIndicators = () => {
  useUiStore.getState().setTabBarIndicators([]);
};

export const getPaymentMethodsIndicator = (
  tabBarIndicatorsList: TabBarIndicator[]
) => {
  return (
    tabBarIndicatorsList.find(
      (indicator) => indicator.indicatorRef === 'CARD_EXPIRING_SOON'
    ) || undefined
  );
};

export const handleSubscriptionPaymentFailedIndicator = (
  isSubscriptionPaymentFailed: boolean
) => {
  const { tabBarIndicators, setTabBarIndicators } = useUiStore.getState();

  const filtered = tabBarIndicators.filter(
    (i) => i.indicatorRef !== 'SUBSCRIPTION_PAYMENT_FAILED'
  );

  setTabBarIndicators(
    isSubscriptionPaymentFailed
      ? [
          ...filtered,
          {
            tabLocalizationKey: 'navigation.account',
            indicatorType: 'error',
            indicatorNumber: 1,
            indicatorRef: 'SUBSCRIPTION_PAYMENT_FAILED',
          },
        ]
      : filtered
  );
};
